import "./form-activity.scss";

import { ActivityFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

import { useQyGetUtilActivityType } from "../../../factory/query/util-activity-type.query";
import { LabelValue } from "../../../shared/models/label-value.interface";
import DropdownControl from "../../../shared/ui/hook-form/dropdown-control/dropdown-control";
import useAutocompleteLocation from "../../location/autocomplete-location/autocomplete-location";


type InputFormSchema = ActivityFormSchema;
export function FormActivity() {
  const { control, setValue, getValues } = useFormContext<ActivityFormSchema>();
  const [activityTypes, setActivityTypes] = useState<LabelValue[]>([]);
  const { formElement: autocompleteLocation } = useAutocompleteLocation(
    getValues("location") || "",
    "location",
    "Location",
    "",
    (selectedLocation) => {
      setValue("location", selectedLocation?.value || "");
    }
  );
  useQyGetUtilActivityType(
    "",
    9999,
    0,
    undefined,
    undefined,
    true,
    (response) => {
      const mappedSuggestions = (response?.data || [])
        .map((item) => ({
          label: `${item.name}`,
          value: item.code,
        }))
        .filter((x) => !!x.label);
      // Set the suggestions for the dropdown control
      setActivityTypes(mappedSuggestions);
    }
  );
  return (
    <div id="FormActivity" className="activity">
      {autocompleteLocation}
      <DropdownControl<InputFormSchema>
        control={control}
        name="activityType"
        label="Activity Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter activityType"
        options={activityTypes}
      />
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isChildActivity"
        label="Is Child Activity"
        containerClassName="pb-2"
      />
      {/* <InputDigitControl<InputFormSchema>
        control={control}
        name="childRate"
        label="Child Rate"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter childRate"
      /> */}
      <CheckboxControl<InputFormSchema>
        control={control}
        name="showAsOptional"
        label="Show As Optional"
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isFree"
        label="Is Free"
        containerClassName="pb-2"
      />
      {/* <InputDigitControl<InputFormSchema>
        control={control}
        name="entranceFee"
        label="Entrance Fee"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter entranceFee"
      /> */}
    </div>
  );
}

export default FormActivity;
